import SubscriptionLogicController from './SubscriptionLogicController';

export default SubscriptionLogicController;
